export default __webpack_public_path__ + "static/roundLogo-45046e5619e6280a1073a294d0ae1f60.png";